import React from "react";
import { Toaster } from "react-hot-toast";

const baseStyle = {
  borderRadius: "12px",
  padding: "12px 16px",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: 1.4,
  maxWidth: "420px",
  border: "1px solid transparent",
  boxShadow:
    "0 10px 28px rgba(6, 46, 46, 0.16), 0 2px 8px rgba(0, 0, 0, 0.06)",
};

const AppToaster = () => (
  <Toaster
    position="top-right"
    reverseOrder={false}
    gutter={10}
    containerStyle={{ top: 16, right: 16, zIndex: 12000 }}
    toastOptions={{
      duration: 4000,
      style: {
        ...baseStyle,
        background: "#ffffff",
        color: "#1a4d4d",
      },
      success: {
        duration: 3500,
        style: {
          ...baseStyle,
          background: "#f3faf6",
          color: "#14532d",
          borderColor: "#b7dfc8",
          borderLeft: "4px solid #2a8f5c",
        },
        iconTheme: {
          primary: "#2a8f5c",
          secondary: "#f3faf6",
        },
      },
      error: {
        duration: 5000,
        style: {
          ...baseStyle,
          background: "#fff7f6",
          color: "#7f1d1d",
          borderColor: "#f0c9c9",
          borderLeft: "4px solid #c44536",
        },
        iconTheme: {
          primary: "#c44536",
          secondary: "#fff7f6",
        },
      },
      loading: {
        style: {
          ...baseStyle,
          background: "#f4f8fb",
          color: "#1e3a4c",
          borderColor: "#c5d7e4",
          borderLeft: "4px solid #3d6f8f",
        },
        iconTheme: {
          primary: "#3d6f8f",
          secondary: "#f4f8fb",
        },
      },
      blank: {
        style: {
          ...baseStyle,
          background: "#ffffff",
          color: "#1a4d4d",
          borderColor: "#d7eaea",
          borderLeft: "4px solid #5a7575",
        },
      },
    }}
  />
);

export default AppToaster;
